module.exports = __webpack_public_path__ + "static/media/boutique2.747e620a.png";